import React from 'react'
import './Contact.css'
function Contact() {
  return (
  <div className='contact-card' id='contact'>
    
    <div className='contact-contaniers'>
      <div className='contact-heading'>
      <h2>Contact Me</h2>
       <h5>Get IN Touch</h5>
      </div>

       <div className='contact-contanier'>
        <div className='contact-options'>
          <article className='contact-option'>
            <i className='fa fa-envelope contact-icon'></i>
            <h4>Email</h4>
            <h5>atyantChauhan@gmail.com</h5>
            <a href='mailto:atyantchauhan@gmail.com' target='_blank'>Send Message</a>
          </article>
          <article className='contact-option'>
            <i className='fa fa-linkedin contact-icon'></i>
            <h4>Linkedin</h4>
            <h5>Atyant Chuahan</h5>
            <a href='https://m.me/atyant-kumar-682945222'vtarget='_blank'>Send Message</a>
          </article>
          <article className='contact-option'>
            <i className='fa fa-whatsapp contact-icon'></i>
            <h4>Whatsapp</h4>
            <h5>7078-35-84</h5>
            <a href="https://api.whatsapp.com/send?phone==9170778353084" target='_blank'>Send Message</a>
          </article>
          <article className='contact-option'>
            <i className='fa fa-facebook contact-icon'></i>
            <h4>Facebook</h4>
            <h5>Atyant Chuahn</h5>
            <a href='https://m.me/atyantchauhan007/' target='_blank'>Send Message</a>
          </article>
        </div>
        {/* <form action=''>
          <input type="text" name='name' placeholder=' Your Full Name' required/>
          <input type="email" name='email' placeholder='Your Email' required />
           <textarea name='message'  rows='7' placeholder='Your Message' required></textarea>
           <button type='submit' className='btn'>Send Message</button>

        </form> */}
       </div>
    </div>
  </div>
  )
}

export default Contact